import { useChartColors } from "./useChartColors";

export const usePerformanceTrendColor = (
  startValue: number,
  endValue: number
): string => {
  const { positive, negative } = useChartColors("securitiesChart");

  if (
    startValue == null ||
    endValue == null ||
    Number.isNaN(startValue) ||
    Number.isNaN(endValue)
  ) {
    return positive as string;
  }

  return (endValue - startValue >= 0 ? positive : negative) as string;
};
